'use client';

import './accordionStylingOverride.module.css';
import { useState } from 'react';
import { RichText } from '../RichText/RichText';
import { AccordionData } from './types';
import CirclePlusIcon from '../Icons/CirclePlusIcon';
import CircleMinusIcon from '../Icons/CircleMinusIcon';

const Accordion: React.FC<{ data: AccordionData }> = ({ data }) => {
  const { items, showNumbers = false, anchorId } = data;
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      id={anchorId}
      className='w-full overflow-y-hidden scroll-mt-32'
    >
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        const itemNumber = (index + 1).toString().padStart(2, '0');
        const itemId = `accordion-item-${index}`;
        const buttonId = `accordion-button-${index}`;
        const panelId = `accordion-panel-${index}`;

        return (
          <article
            key={index}
            id={itemId}
            className='border-b border-gray-200 first:border-t'
          >
            <button
              id={buttonId}
              onClick={() => toggleItem(index)}
              aria-expanded={isOpen}
              aria-controls={panelId}
              className='w-full cursor-pointer flex items-start justify-between gap-4 py-6 text-left transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2'
            >
              <span className='flex items-top flex-1 min-w-0'>
                {showNumbers && (
                  <span
                    className='text-accordion-number-token font-semibold text-lg shrink-0 max-lg:mr-4 lg:ml-4'
                    aria-hidden='true'
                  >
                    {itemNumber}
                  </span>
                )}
                <span className='font-semibold text-lg text-inherit text-left lg:px-4'>
                  {item.title}
                </span>
              </span>
              <span className='shrink-0 lg:mr-4'>
                {isOpen ? (
                  <CircleMinusIcon
                    variant='solid'
                    className='text-brand-icon'
                  />
                ) : (
                  <CirclePlusIcon
                    variant='soft'
                    className='text-brand-icon'
                  />
                )}
              </span>
            </button>
            <div
              id={panelId}
              className={`overflow-hidden ${showNumbers ? 'px-9 lg:px-14' : 'px-0 lg:px-4'} transition-all duration-300 ease-in-out ${
                isOpen ? 'max-h-500 opacity-100' : 'max-h-0 opacity-0 invisible'
              }`}
            >
              <div className='pb-6 lg:pt-2 text-gray-600 leading-relaxed'>
                <RichText data={{ content: item.copy }} />
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default Accordion;
